import { entitySubtypes } from '../config/config';



export const isDefaultGroup = (group) => {
  return [ entitySubtypes.main, entitySubtypes.usual, entitySubtypes.cloud ].includes(group?.subtype);
};
